import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { About } from "@/components/site/About";
import { Expertise } from "@/components/site/Expertise";
import { CancerRibbons } from "@/components/site/CancerRibbons";
import { Manifesto } from "@/components/site/Manifesto";
import { Research } from "@/components/site/Research";
import { Honors } from "@/components/site/Honors";
import { Testimonials } from "@/components/site/Testimonials";
import { Poster } from "@/components/site/Poster";
import { Appointment } from "@/components/site/Appointment";
import { Footer } from "@/components/site/Footer";
import { FloatingActions } from "@/components/site/FloatingActions";
import { AppointmentDialog } from "@/components/site/AppointmentDialog";
import AdminPage from "@/AdminPage";

function Home() {
  const [bookOpen, setBookOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const seen = sessionStorage.getItem("appt_prompt_seen");
    if (!seen) {
      const t = setTimeout(() => {
        setBookOpen(true);
        sessionStorage.setItem("appt_prompt_seen", "1");
      }, 3500);
      return () => clearTimeout(t);
    }
  }, []);

  const openBook = () => setBookOpen(true);

  return (
    <div className="App grain bg-[#FDFBF7] min-h-screen">
      <Nav onBook={openBook} />
      <main>
        <Hero onBook={openBook} />
        <Ribbon />
        <About />
        <Expertise />
        <CancerRibbons onBook={openBook} />
        <Manifesto />
        <Research />
        <Honors />
        <Testimonials />
        <Poster />
        <Appointment />
      </main>
      <Footer />
      <FloatingActions />
      <AppointmentDialog open={bookOpen} onOpenChange={setBookOpen} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
